export default "__VITE_ASSET__C2AB$V4K__"